import React, { ComponentType, FC } from 'react'
import { Link, RouteComponentProps } from 'react-router-dom'
import store from '../../store'
import SetTheme from '../../utils/SetTheme'
import { Avatar } from 'antd'
import { Redirect } from 'react-router'
import { makePath } from '../../helpers/path'
import { Typography } from 'antd'
import BottomBar from '../Home/BottomBar'

const { Text } = Typography

const AuthLayout = (Component: ComponentType<object>): FC<RouteComponentProps> => (props: RouteComponentProps) => {
	const prefixState = store.getState().prefix


	if (props['location'].pathname === "/login") {
		const token = localStorage.getItem('x-auth')
		if (token) {
			if (prefixState?.info?.game === "ambking" ||
				(prefixState?.info?.game === "betflix" && prefixState.info?.functions.betflixOnListgame) ||
				(prefixState?.info?.game === "pgoon" && prefixState.info?.functions.pgoonOnListgame)
			) {
				return <Redirect to={makePath('/launch-game')} />
			}
			return <Redirect to={makePath('/wallet')} />
		}
	} else {
		localStorage.removeItem('x-auth')
	}

	// const showMenuSupport = prefixState?.info?.socialMedia.line ? true : false
	// const handleAlert = () => { }
	// const handleModalPromotionst = () => { }
	// const handleModalSupport = () => { }

	return (
		<>
			<SetTheme />
			<div className='auth-container'>
				{/* <div className='auth-back-home'>
					{(prefixState?.info?.functions.hasOwnProperty("homePage") && prefixState?.info?.functions['homePage']) && (
						<Link to={makePath('/home')}>
							<div>
								<Text><i className="fa-regular fa-arrow-left" style={{ fontSize: '18px', marginRight: 5 }}></i> กลับหน้าหลัก</Text>
							</div>
						</Link>
					)}
				</div> */}
				<div className='auth-content'>
					{prefixState.info?.logo ? (
						<Avatar
							className="avatar-logo avatar-logo-login"
							style={{
								width: prefixState.info?.prefix === "782S" ? '150px' : (prefixState.info?.prefix === "ALD88" || prefixState.info?.prefix === "ROMA911") ? '240px' : undefined,
								height: prefixState.info?.prefix === "782S" ? '200px' : undefined
							}}
							src={prefixState.info?.logo}
							shape="square"
						/>
					) : (
						<Avatar
							className="avatar-logo"
							shape="square"
							size={125}>
							{prefixState.info?.prefix}
						</Avatar>
					)}
					<Component {...props} />
				</div>
			</div>
			<BottomBar prefix={prefixState.info} />
		</>
	)
}

export default AuthLayout
